import { render, staticRenderFns } from "./UserMonitor.vue?vue&type=template&id=4dfa748e"
import script from "./UserMonitor.vue?vue&type=script&lang=js"
export * from "./UserMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports